<template>
    <div>
        <div v-if="value.sales_rank">
            {{ value.sales_rank | numberFormat }}
        </div>
        <div v-if="salesRankHistory">
            <Sparkline
                :data="salesRankHistory"
                reverse-y-axis
                x-axis-type="datetime"
                series-name="Sales Rank"
                />
        </div>
    </div>
</template>

<script>
import { fetchProductDataHistory } from '@/api/productDataHistory';
import Sparkline from '@/components/highcharts/Sparkline.vue';

export default {
    props: ['value'],
    components: {
        Sparkline,
    },
    data() {
        return {
            productDataHistory: null,
        };
    },
    watch: {
        'value.amazon_product_id': {
            immediate: true,
            handler() {
                this.updateData();
            },
        },
    },
    computed: {
        salesRankHistory() {
            if (this.productDataHistory && this.productDataHistory.data) {
                return this.productDataHistory.data.reverse().map(e => ([
                    Date.parse(e.retrieved_at),
                    e.sales_rank,
                ]));
            }
        },
    },
    methods: {
        async updateData() {
            this.productDataHistory = null;

            if (this.value.amazon_product_id) {
                // Batched across the whole page: a request per row exhausted the
                // api throttle in three page views. See api/productDataHistory.
                this.productDataHistory = await fetchProductDataHistory(this.value.amazon_product_id);
            }
        },
    },
}
</script>
